export class DocumentPagesViewed {
  [key: number]: boolean;
}
